<template>
  <section id="savings">
    <v-container>
      <v-card class="text-center" tile elevation="0">
        <v-card-title class="justify-center"
          ><h2 class="topic wordBreak">
            {{ $cms.get(content, 'header') }}
          </h2></v-card-title
        >
        <v-card-text class="pt-12">
          <p class="slider-value pt-sm-12 pb-4">
            {{ sliderValue }}
          </p>
          <h3 class="pt-4">{{ $cms.get(content, 'per_month') }}</h3>
          <v-row justify="center"
            ><v-col cols="12" sm="10" xl="7">
              <Slider v-model="sliderValue" /></v-col
          ></v-row>
          <v-row justify="center"
            ><v-col cols="12" sm="8" xl="5"
              ><Price :value="sliderValue" /></v-col
          ></v-row>
        </v-card-text>
      </v-card>
      <Entries />
    </v-container>
  </section>
</template>

<script>
import Slider from './Slider.vue'
import Price from './Price.vue'
import Entries from './Entries.vue'
import savingsJSON from '@/data/json/homepage/savings/savings.json'
export default {
  components: {
    Slider,
    Price,
    Entries
  },
  data() {
    return {
      content: savingsJSON.data,
      sliderValue: 250
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  color: var(--v-primary-base);
  font-weight: normal;
}
.slider-value {
  font-size: 6.62rem;
  font-weight: bold;
  color: var(--v-primary-base);
}
</style>
